import React, { Component } from "react"
import Modal from "../modal/modal"
import SearchSection from "./search-section"
import { isSafari } from "react-device-detect"

export default class SearchSectionModal extends Component {
  afterModalOpenHandler = () => {
    const input = document.querySelector(".searchinput")
    if (input) {
      input.focus()
    }
  }

  render() {
    if (this.props.searchOpen) {
      return (
        <Modal
          isOpen={true}
          hideClose={true}
          closeHandler={this.props.closeHandler}
          afterOpenHandler={this.afterModalOpenHandler}
          noScrollToTop="true"
          modifier={`modal--wide modal--fixed site-header ${isSafari ? "safari-only" : ""}`}
          overlayModifier="ReactModal__Overlay--fixed header-container"
          bodyModifier="ReactModal__Body--open ReactModal--no-overflow"
        >
          <SearchSection {...this.props} isSearchActive={true} closeHandler={this.props.closeHandler} />
        </Modal>
      )
    } else {
      return ""
    }
  }
}
